export enum EcommerceBehaviorSellerList {
	AlwaysShow = 0,
	ShowWhenOnlyAvailable = 1,
}
